<template>
    <div class="doc-section">
        <h1>Editar Ubicación</h1>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p style="margin-top: 16px;">
            Para editar una ubicación, haga clic sobre el botón <strong>Editar</strong> en la tabla de ubicaciones
            guardadas, sobre la fila del marcador que desea modificar. Al hacerlo, se mostrará en el mapa el marcador y
            la herramienta de edición.
        </p>

        <h2>Pasos para editar una ubicación</h2>
        <p>Siga esta secuencia para actualizar la información geográfica y descriptiva:</p>

        <ol class="ul-contenedor step-list">
            <li>Hacer clic sobre el botón <strong>Editar</strong> ubicado en el mapa.</li>
            <li>Arrastrar el marcador al lugar deseado y hacer clic en el botón <strong>Guardar</strong> situado sobre
                el mapa. Note que en el formulario ubicado debajo del mapa los campos se actualizarán.</li>
            <li>Editar el nombre de la ubicación guardada si es necesario.</li>
            <li>Modificar la latitud de la ubicación (opcional si se hace manualmente).</li>
            <li>Modificar la longitud de la ubicación (opcional si se hace manualmente).</li>
            <li>Hacer clic en el botón <strong>Cancelar</strong> para rechazar la actualización de los datos y mantener
                los valores anteriores.</li>
            <li>Hacer clic sobre el botón <strong>Guardar ubicación</strong> para actualizar los datos en la base de
                datos.</li>
            
        </ol>

        <div class="info-card">
            <p>
                <strong>Confirmación:</strong> Al actualizar la ubicación, aparecerá una notificación en la parte
                superior indicando que los cambios fueron guardados exitosamente.
            </p>
        </div>


        <h3>Referencia Visual de Edición</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesEditar" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesEditarMoviles" />
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {

    name: 'EditarUbicacion',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesEditar: [
            {
                nombre: "Opciones de Edición",
                url: "img/ubicaciones/opcionesParaEditar.png",
                descripcion: "Herramientas de edición sobre el mapa."
            },
            {
                nombre: "Formulario de Edición",
                url: "img/ubicaciones/formularioEditarUbicacion.png",
                descripcion: "Campos de texto y coordenadas para modificar."
            },
            {
                nombre: "Mensaje de Actualización",
                url: "img/ubicaciones/exitoActualizarUbicacion.png",
                descripcion: "Notificación de cambios guardados exitosamente."
            }
        ],
        imagenesEditarMoviles: [
            {
                nombre: "Opciones de Edición",
                url: "img/ubicaciones/moviles/opcionesParaEditar.png",
                descripcion: "Herramientas de edición sobre el mapa."
            },
            {
                nombre: "Formulario de Edición",
                url: "img/ubicaciones/moviles/formularioEditarUbicacion.png",
                descripcion: "Campos de texto y coordenadas para modificar."
            },
            {
                nombre: "Mensaje de Actualización",
                url: "img/ubicaciones/exitoActualizarUbicacion.png",
                descripcion: "Notificación de cambios guardados exitosamente."
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>